import { useMutation, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';
import UserService from '../../services/user.service';
import { COMPANY_MEMBERS_QUERY_KEY, CUSTOMER_QUERY_KEY } from '../../constants/query';
import useQueryData from '../useQueryData';
import { customerIdSelector } from '../../selectors/customer';
import { pagesText } from '../../constants/pagesText';

const useUpdateUserStatus = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const customerId = useQueryData(CUSTOMER_QUERY_KEY, customerIdSelector);

  return useMutation(UserService.updateUserStatus, {
    onMutate: async newData => {
      await queryClient.cancelQueries([COMPANY_MEMBERS_QUERY_KEY, customerId]);

      const previousData = queryClient.getQueryData([COMPANY_MEMBERS_QUERY_KEY, customerId]);

      queryClient.setQueryData([COMPANY_MEMBERS_QUERY_KEY, customerId], oldData => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map(page => ({
            ...page,
            companyMembers: page.companyMembers.map(user =>
              user.userId === newData.userId ? { ...user, isActive: !user.isActive } : user,
            ),
          })),
        };
      });

      return { previousData };
    },

    onError: (_err, _newData, context) => {
      if (context?.previousData) {
        queryClient.setQueryData([COMPANY_MEMBERS_QUERY_KEY, customerId], context.previousData);
      }
      enqueueSnackbar(pagesText.somethingWentWrong, {
        variant: 'error',
        autoHideDuration: 3000,
      });
    },

    onSuccess: () => {
      enqueueSnackbar(pagesText.companyMembers.successfullyUpdateUserStatus, {
        variant: 'success',
        autoHideDuration: 3000,
      });
    },
  });
};

export default useUpdateUserStatus;
